module.exports = __webpack_public_path__ + "img/earnm.1d9ea27b.svg";